var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2906 0.601995C14.977 0.788181 15.5176 1.33681 15.7011 2.03343C16.0345 3.29609 16.0345 5.93051 16.0345 5.93051C16.0345 5.93051 16.0345 8.56492 15.7011 9.82758C15.5176 10.5242 14.977 11.05 14.2906 11.2362C13.0464 11.5745 8.0573 11.5745 8.0573 11.5745C8.0573 11.5745 3.06823 11.5745 1.824 11.2362C1.13757 11.05 0.596951 10.5242 0.413462 9.82758C0.0800781 8.56492 0.0800781 5.93051 0.0800781 5.93051C0.0800781 5.93051 0.0800781 3.29609 0.413462 2.03343C0.596951 1.33681 1.13757 0.788211 1.824 0.601995C3.06823 0.263672 8.0573 0.263672 8.0573 0.263672C8.0573 0.263672 13.0464 0.263672 14.2906 0.601995ZM10.5955 5.93056L6.42558 3.53865V8.32236L10.5955 5.93056Z",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_2187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2906 0.601995C14.977 0.788181 15.5176 1.33681 15.7011 2.03343C16.0345 3.29609 16.0345 5.93051 16.0345 5.93051C16.0345 5.93051 16.0345 8.56492 15.7011 9.82758C15.5176 10.5242 14.977 11.05 14.2906 11.2362C13.0464 11.5745 8.0573 11.5745 8.0573 11.5745C8.0573 11.5745 3.06823 11.5745 1.824 11.2362C1.13757 11.05 0.596951 10.5242 0.413462 9.82758C0.0800781 8.56492 0.0800781 5.93051 0.0800781 5.93051C0.0800781 5.93051 0.0800781 3.29609 0.413462 2.03343C0.596951 1.33681 1.13757 0.788211 1.824 0.601995C3.06823 0.263672 8.0573 0.263672 8.0573 0.263672C8.0573 0.263672 13.0464 0.263672 14.2906 0.601995ZM10.5955 5.93056L6.42558 3.53865V8.32236L10.5955 5.93056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_2187)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeB);
export default __webpack_public_path__ + "static/media/youtubeB.1eaa0ca5bfb5169b8dbe6a4f95959130.svg";
export { ForwardRef as ReactComponent };